<template>
<!--  3:04-->
  <div>
    <cancel-heading>Want a Deal? Get 66% off for 3 months!</cancel-heading>

    <p>Get Forefront for only 1/3 of your normal price for the next 3 months. That's the same as getting two months completely free!  Continue experiencing all that Forefront has to offer, including:</p>

    <cancel-feature-list/>

    <cancel-box
      label="Claim your limited-item offer:"
      heading="66% off for 3 months"
    >
      <button-default @click="acceptDiscountOffer">Accept This Offer</button-default>
    </cancel-box>
  </div>
</template>

<script>
import CancelBox from "./components/CancelBox.vue";
import CancelFeatureList from "./components/CancelFeatureList.vue";
import CancelHeading from "./components/CancelHeading.vue";

export default {
  name: "OfferDiscount",
  components: {CancelHeading, CancelFeatureList, CancelBox},
  methods: {
    acceptDiscountOffer() {
      this.$emit('accepted')
    }
  },
}
</script>
